import React, { Component } from "react";
import * as logger from "../../../shared/logger";

import ColorPicker from "../../form-inputs/color-picker";

class ColorPickerExample extends Component {
    constructor(props) {
        super();
        this.state = {
            selectedValue: [],
            data: [],
        };
    }

    updateField = (name, value) => {
        logger.log("reports back", name, value);
    };

    render() {
        return <ColorPicker name="colorPicker" defaultValue={this.state.selectedValue} updateField={this.updateField} />;
    }
}

export default ColorPickerExample;
